import { Component, OnInit, Input, ViewChild, OnDestroy } from "@angular/core";
import { Router } from "@angular/router";
import { Subject } from "rxjs/";
import { AlertService, CountryService, AppService } from "../_services/index";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { DataTableDirective } from "angular-datatables";
import { EncryptionService } from "../_services/encryption.service";
import { HttpClient } from "@angular/common/http";

class DataTablesResponse {
  data: any[];
  draw: number;
  recordsFiltered: number;
  recordsTotal: number;
}

class Country {
  id: number;
  sortname: string;
  country_name: string;
  phonecode: string;
  created_by_name: string;
  created_at: string;
  is_active: string;
}

@Component({
  selector: "app-country",
  templateUrl: "./country.component.html",
})
export class CountryComponent implements OnInit, OnDestroy {
  @ViewChild(DataTableDirective, { static: false })
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable
  countryList: Country[] = [];
  countryListTotal: any;
  isSubmitted = false;

  getCountry = {
    id: "",
    sortname: "",
    country_name: "",
    phonecode: "",
    is_active: "N",
  };
  modalReference: NgbActiveModal;
  modalTitle: string;
  start: number = 0;
  pageLength: number = 10;

  constructor(
    public router: Router,
    private dataService: CountryService,
    private alertService: AlertService,
    private AppService: AppService,
    private modalService: NgbModal,
    private enc_dec: EncryptionService,
    private http: HttpClient,
  ) {}

  country = {
    id: "",
    sortname: "",
    country_name: "",
    phonecode: "",
    is_active: "Y",
  };

  showloding = true;
  lodingImage = false;

  ngOnInit() {
    window.scroll(0, 0);

    this.getCountryListing();

    // this.allCountry();
  }

  getCountryListing() {
    this.dtOptions = {
      pagingType: "full_numbers",
      pageLength: this.pageLength,
      serverSide: true,
      processing: true,
      ajax: (dataTablesParameters: any, callback) => {
        this.start = dataTablesParameters.start;
        this.pageLength = dataTablesParameters.length;

        this.http
          .post<DataTablesResponse>(
            "/api/all-country-datatable",
            {
              req_data: this.enc_dec.encrypt(
                JSON.stringify(Object.assign(dataTablesParameters)),
              ),
            },
            {},
          )
          .subscribe((response: any) => {
            const output = this.enc_dec.decrypt(response.res_data);
            const resp = JSON.parse(output);
            this.countryList = resp.data || [];
            this.countryListTotal = resp["recordsTotal"];

            callback({
              recordsTotal: resp["recordsTotal"],
              recordsFiltered: resp["recordsFiltered"],
              data: [],
            });
          });
      },
      columns: [
        { data: "id" },
        { data: "country_name" },
        { data: "sortname" },
        { data: "created_at" },
        { data: "is_active" },
        { data: null },
      ],
    };
  }


  
  getRowNumber(index: number): number {
    return this.start + index + 1;
  }
  

  // allCountry() {
  //   this.loadShow();
  //   this.dataService
  //     .getAllCountry()
  //     .pipe()
  //     .subscribe((data) => {
  //       this.countryList = data["country"];
  //       this.rerender();
  //       this.loadHide();
  //     });
  // }

  open(content) {
    this.isSubmitted = false;
    if (this.getCountry.id != null) {
      this.getCountry.id = "";
    }
    ((this.country.sortname = ""),
      (this.country.country_name = ""),
      (this.country.phonecode = ""),
      (this.country.is_active = "Y"));
    this.modalTitle = "Add Country";
    this.modalReference = this.modalService.open(content, {
      backdrop: "static",
      keyboard: false,
    });
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      dtInstance.destroy();
      this.dtTrigger.next();
    });
  }

  edit(id, content) {
    this.loadShow();
    this.dataService
      .getCountry(id)
      .pipe()
      .subscribe((data) => {
        this.getCountry = data["country"];
        this.country = {
          id: this.getCountry.id,
          sortname: this.getCountry.sortname,
          country_name: this.getCountry.country_name,
          phonecode: this.getCountry.phonecode,
          is_active: this.getCountry.is_active,
        };
        this.loadHide();
        this.modalTitle = "Edit Country";
        this.modalReference = this.modalService.open(content, {
          backdrop: "static",
          keyboard: false,
        });
      });
  }

  isFieldsInvalid(value: string): boolean {
    return !value || value.trim().length === 0;
  }

  save(val, f) {
    this.isSubmitted = true;

    if (
      this.isFieldsInvalid(this.country.country_name) ||
      this.isFieldsInvalid(this.country.sortname) ||
      this.isFieldsInvalid(this.country.phonecode)
    ) {
      return;
    }
    if (f.form.valid) {
      this.loadShow();
      if (val.id == "") {
        this.dataService
          .save(this.country)
          .pipe()
          .subscribe(
            (data) => {
              this.loadHide();
              this.modalReference.close();
              this.alertService.success("Country saved successfully", true);
              const table = $("#country_tab").DataTable();
              table.ajax.reload(null, false);
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            },
          );
      } else {
        this.dataService
          .countryUpdate(this.country)
          .pipe()
          .subscribe(
            (data) => {
              this.modalReference.close();
              this.alertService.success("Country updated successfully", true);
              const table = $("#country_tab").DataTable();
              table.ajax.reload(null, false);
            },
            (error) => {
              this.loadHide();
              this.alertService.error(error);
              document
                .querySelector(".modal")
                .scrollTo({ top: 0, behavior: "smooth" });
            },
          );
      }
    }
  }

  delete(item) {
    this.loadShow();
    this.dataService
      .countryDelete(item.id)
      .pipe()
      .subscribe(
        (data) => {
          if (data["status"] == 200) {
            this.alertService.success("Country deleted successfully", true);
            item.is_active = item.is_active === "Y" ? "N" : "Y";
            const table = $("#country_tab").DataTable();
            table.ajax.reload(null, false);
          } else {
            this.alertService.error("Country error");
          }
        },
        (error) => {
          this.alertService.error(error);
        },
      );
    this.loadHide();
  }

  loadShow() {
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide() {
    this.showloding = false;
    this.lodingImage = true;
  }
}
